/* eslint-disable no-redeclare */

export const numberFormatHelper = function (
  n: number,
  c: number,
  d: string,
  t: string
) {
  // function pulled in from gesb website cutup. Originally called Number.format()
  // Renamed so does not trample the global Number object
  c = isNaN((c = Math.abs(c))) ? 2 : c
  d = d == undefined ? "." : d
  t = t == undefined ? "," : t

  const s = n < 0 ? "-" : ""
  const i = parseInt(Math.abs(+n || 0).toFixed(c)) + ""
  const j = i.length > 3 ? i.length % 3 : 0

  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - Number(i))
          .toFixed(c)
          .slice(2)
      : "")
  )
}

export function roundToNearest(
  number: number,
  near: number,
  direction: "down" | "up"
) {
  if (number % near === 0) return number
  if (direction === "up") {
    return Math.trunc(number / near) * near + near
  }
  return Math.trunc(number / near) * near
}

export function percentage(numA: number, numB: number) {
  return (numA / numB) * 100
}

export function cleanNumberInputs(numString: string) {
  return Number(numString.replace(/,/g, ""))
}

/**
 * @deprecated use the formatMoney instead due to weird
 * rounding issue https://squizgroup.atlassian.net/browse/GESBRI-93
 * @param x
 */
export function numberWithCommas(x: string | number) {
  //https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
  const formattedNum = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  // add a trailing zero if decimal point is only one number
  const decimals = formattedNum.split(".")[1]
  if (formattedNum.includes(".") && decimals.length == 1) {
    return formattedNum + "0"
  } else {
    return formattedNum
  }
}
